import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg m-8 p-8 w-full" }
const _hoisted_2 = { class: "border-b border-grey-200 mb-4" }
const _hoisted_3 = { class: "text-grey-700 text-xl text-semibold" }
const _hoisted_4 = { id: "subnet-calculator" }
const _hoisted_5 = { class: "border border-solid border-gray-400 p-3 rounded-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("legend", { class: "block tracking-wide text-gray-700 text-s font-semibold mb-1" }, "Input", -1)
const _hoisted_7 = { class: "grid sm:grid-cols-3 gr" }
const _hoisted_8 = { class: "border border-solid border-gray-400 p-3 rounded-lg" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("legend", { class: "block tracking-wide text-gray-700 text-s font-semibold mb-1" }, "Output", -1)
const _hoisted_10 = { class: "grid sm:grid-cols-3 gr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select = _resolveComponent("base-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", _hoisted_4, [
        _createElementVNode("fieldset", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_base_input, {
              "data-testid": "ipaddress",
              label: "IP Address",
              error: _ctx.ipAddressError,
              modelValue: _ctx.ipAddress,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ipAddress) = $event)),
              onChange: _ctx.ipAddressChange
            }, null, 8, ["error", "modelValue", "onChange"]),
            _createVNode(_component_base_input, {
              "data-testid": "subnetmask",
              label: "Subnet Mask",
              error: _ctx.subnetMaskError,
              modelValue: _ctx.subnetMask,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subnetMask) = $event)),
              onChange: _ctx.subnetMaskChange
            }, null, 8, ["error", "modelValue", "onChange"]),
            _createVNode(_component_base_select, {
              "data-testid": "maskbits",
              label: "Mask Bits",
              modelValue: _ctx.maskBits,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maskBits) = $event)),
              options: _ctx.maskBitOptions
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("fieldset", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_base_input, {
              label: "IP Address CIDR",
              modelValue: _ctx.ipAddressCidr,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ipAddressCidr) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_base_input, {
              "data-testid": "subnetid",
              label: "Subnet ID",
              modelValue: _ctx.subnetId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.subnetId) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_base_input, {
              "data-testid": "broadcast",
              label: "Broadcast",
              modelValue: _ctx.broadcast,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.broadcast) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_base_input, {
              label: "Host Range",
              modelValue: _ctx.hostRange,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hostRange) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_base_input, {
              "data-testid": "maxhosts",
              label: "Max Hosts",
              modelValue: _ctx.maxHosts,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.maxHosts) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_base_input, {
              "data-testid": "maxsubnets",
              label: "Max Subnets",
              modelValue: _ctx.maxSubnets,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.maxSubnets) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}